<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tit1"><a id="page_iii"></a>Civil War Monuments</h1>
<h1 class="tit2">and Memory</h1>
<p class="stit1">Favorite Stories and Fresh Perspectives</p>
<p class="stit1">from the Historians at Emerging Civil War</p>
<p class="edi1">Edited by</p>
<p class="edi2">Jonathan Tracey &amp; Chris Mackowski</p>
<div class="img_container">
<img alt="Images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?53e07fb9